import { MenuItem } from '@material-ui/core';
import React, { forwardRef } from 'react';

export interface SelectOptionProps {
    value: string|number;
    children: string;
    empty?: boolean;
}

const SelectOption = forwardRef<HTMLLIElement, SelectOptionProps>(
    function SelectOption(
        { value, children, empty, ...otherProps },
        ref,
    ) {
        return (
            <MenuItem
                value={value}
                {...otherProps}
                ref={ref}
            >
                {
                    empty
                        ? <em>{children}</em>
                        : children
                }
            </MenuItem>
        );
    },
);

export default SelectOption;
